<template>
  <footer id="Contact" class="footer">
    <div class="footer-content">
      <a :href="`tel:${this.text.phoneNumber}`" class="footer-item">
        <div class="footer-icon">
          <i class="fa-solid fa-phone"></i>
        </div>
        <div class="footer-text">
          <span>{{this.text.phoneNumber}}</span>
        </div>
      </a>
      
      <a :href="`mailto:${this.text.email}`" class="footer-item">
        <div class="footer-icon">
          <i class="fa-solid fa-envelope"></i>
        </div>
        <div class="footer-text">
          <span>{{this.text.email}}</span>
        </div>
      </a>
      
      <a :href="this.text.socials.instagram.url" target="_blank" class="footer-item">
        <div class="footer-icon">
          <i class="fa-brands fa-instagram"></i>
        </div>
        <div class="footer-text">
          <span>{{this.text.socials.instagram.name}}</span>
        </div>
      </a>
      
      <a :href="this.text.socials.facebook.url" target="_blank" class="footer-item">
        <div class="footer-icon">
          <i class="fa-brands fa-facebook"></i>
        </div>
        <div class="footer-text">
          <span>{{this.text.socials.facebook.name}}</span>
        </div>
      </a>
    </div>
  </footer>
</template>

<script>
import json from '../../text.json'
export default {
  name: "myFooter",

  data() {
    return {
      text: json
    }
  },
}
</script>

<style scoped>

</style>
